import { NodeTypeName } from "@app/types";
import BaseNodeModel from "../BaseNodeModel";

export default class FlushPromptsNodeModel extends BaseNodeModel {
    /**
     * Input node model
     * @module FlushPromptsNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = NodeTypeName.flushPrompts;
        this.props.colorClass = "blue";
        this.props.iconClass = "zap";
        this.DEFAULT_COLOR_CLASS = "blue";
        this.applyProps(props);
    }

    setConfig(key, value) {
        
        super.setConfig(key, value);
        
    }

    

    getConfigViews() {
        return [...this.getConfigViewNameField(),
        ...[
            { type: "Textarea", label: this.getPropLabel("description"), key: "description", value: "Forces all queued prompts to be outputted without a Data Access / Input node."},
            { type: "Textarea", label: this.getPropLabel("note"), key: "note" }
        ]
        ];
    }
}